import { TStore } from "redux/reducer";
import { createSelector } from "reselect";

export const selectUsersState = (state: TStore) => state.userPage;

export const selectUsersPageState = createSelector([selectUsersState], (state) => state);

export const selectUsersPageBtnLoading = createSelector([selectUsersState], (state) => state.btnLoading);
